import { RestAdapter } from '../restAdapter';
import { Adapter, RestAdapterParams } from '../commonTypes';

export type AdapterParams = {
  apiAdapter: Adapter;
};

export function createAdapter(
  params: AdapterParams | RestAdapterParams
): Adapter {
  if ('apiAdapter' in params) {
    return params.apiAdapter;
  } else {
    return new RestAdapter(params);
  }
}
